import {
    IMPORT_BOOKING_LIST,
    IMPORT_BOOKING_PAGINATION,
    IMPORT_BOOKING_SUMMARY,
    IMPORT_BOOKING_CANCEL_LIST,
    IMPORT_BOOKING_CANCEL_PAGINATION,
    IMPORT_BOOKING_CANCEL_SUMMARY
} from './constant';

export const initStateFeed = {
    importbookingList: [],
    importpagination: {},
    importsummary: {},
    importcancelBookingList: [],
    importcancelPagination: {},
    importcancelSummary: {},
};
export const IMPORT_BOOKING_SUMMARY_INIT = 'IMPORT_BOOKING_SUMMARY_INIT';

export default (state = initStateFeed, action) => {
    switch (action.type) {
        case IMPORT_BOOKING_LIST: {
            return {
                ...state,
                importbookingList: action.payload,
            };
        }
        case IMPORT_BOOKING_PAGINATION: {
            return {
                ...state,
                importpagination: action.payload,
            };
        }
        case IMPORT_BOOKING_SUMMARY: {
            return {
                ...state,
                importsummary: action.payload,
            };
        }
    
        case IMPORT_BOOKING_CANCEL_LIST: {
            return {
                ...state,
                importcancelBookingList: action.payload,
            };
        }
        case IMPORT_BOOKING_CANCEL_PAGINATION: {
            return {
                ...state,
                importcancelPagination: action.payload,
            };
        }
        case IMPORT_BOOKING_CANCEL_SUMMARY: {
            return {
                ...state,
                importcancelSummary: action.payload,
            };
        }
        default:
            return state;
    }
};
